import { StyleSheet, Platform } from 'react-native';
import { SPACING, COLORS, TYPOGRAPHY } from '../constants/theme';

/**
 * Shared splash screen styles
 * To change the theme, update the constants in theme.ts
 */
export const SplashStyles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.background.primary,
        justifyContent: 'center',
        alignItems: 'center',
    },
    content: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    logoContainer: {
        marginBottom: SPACING.xl,
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        fontSize: Platform.select({ ios: 36, android: 32, default: 36 }),
        fontWeight: TYPOGRAPHY.fontWeight.bold,
        color: COLORS.white,
        marginBottom: SPACING.md,
        textShadowColor: 'rgba(0, 0, 0, 0.2)',
        textShadowOffset: { width: 0, height: 4 },
        textShadowRadius: 8,
        letterSpacing: 2,
        includeFontPadding: false,
    },
    tagline: {
        fontSize: TYPOGRAPHY.fontSize.lg,
        fontWeight: TYPOGRAPHY.fontWeight.medium,
        color: 'rgba(255, 255, 255, 0.75)',
        marginBottom: SPACING.xl,
        textAlign: 'center',
        includeFontPadding: false,
    },
    loader: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: SPACING.md,
    },
    loaderDot: {
        width: 12,
        height: 12,
        backgroundColor: COLORS.white,
        borderRadius: 6,
    },
});
